import { render, staticRenderFns } from "./wraps.vue?vue&type=template&id=51e3cafd&scoped=true&"
import script from "./wraps.vue?vue&type=script&lang=js&"
export * from "./wraps.vue?vue&type=script&lang=js&"
import style0 from "./wraps.vue?vue&type=style&index=0&id=51e3cafd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e3cafd",
  null
  
)

export default component.exports